module.exports = __webpack_public_path__ + "static/bells-5a1b0b9b1f4aeed1deff2aab6679d892.mp3";